import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDate } from '../../../../util/datetime'
import { formatMoney } from '../../../../util/money'
import { BANK_PAYMENT_TEXT } from '../../state/const'
import { BANK_ZAB } from '../../../../constant/payment-constant'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PAYMENT_LIST_WIDGET } from '../../../process/ui-definition/process-ui'

const moment = require('moment')

const BankPayment = ({ payment }) => {
    const { bankPayment } = payment

    const type = BANK_PAYMENT_TEXT[bankPayment.type]
    let reference = bankPayment.reference
    if (bankPayment.type === BANK_ZAB) {
        reference += ' ' + bankPayment.customerReference
    }

    return (
        <tr>
            <td>{formatDate(payment.date)}</td>
            <td>bank account</td>
            <td>{type}</td>
            <td>{reference}</td>
            <td className="align-right">{formatMoney(payment.amount, payment.currency)}</td>
        </tr>
    )
}

const StripePayment = ({ payment }) => {
    const { stripePayment } = payment
    return (
        <tr>
            <td>{formatDate(payment.date)}</td>
            <td>stripe</td>
            <td>{stripePayment.type}</td>
            <td>
                <a href={'https://dashboard.stripe.com/payments/' + stripePayment.transactionId}
                    target="_blank" rel="noopener noreferrer">{stripePayment.transactionId}<i className="fa fa-external-link"/>
                </a>
            </td>
            <td className="align-right">{formatMoney(payment.amount, payment.currency)}</td>
        </tr>
    )
}

const getPayPalId = ({ paymentExecution }) => {
    if (!paymentExecution) {
        return null
    }

    const { transactions } = paymentExecution
    if (!transactions) {
        return null
    }

    const transaction = transactions[0]
    if (!transaction) {
        return null
    }

    const { related_resources } = transaction
    if (!related_resources) {
        return null
    }

    const related_resource = related_resources[0]
    if (!related_resource) {
        return null
    }

    const { sale } = related_resource
    if (!sale) {
        return null
    }

    return sale.id
}

const PayPalPaymentExecuted = ({ payment }) => {
    const { payPalPaymentExecuted } = payment

    const { payPalPayment } = payPalPaymentExecuted

    if (!payPalPayment) {
        return null
    }
    const payPalId = getPayPalId(payPalPayment)

    return (
        <tr>
            <td>{formatDate(payment.date)}</td>
            <td>paypal</td>
            <td>{payPalPaymentExecuted.type}</td>
            <td><a href={'https://www.paypal.com/activity/payment/' + payPalId} target="_blank" rel="noopener noreferrer">{payPalId}<i
                className="fa fa-external-link"/></a></td>
            <td className="align-right">{formatMoney(payment.amount, payment.currency)}</td>
        </tr>
    )
}


const Payment = ({ payment }) => {
    if (payment.bankPayment) {
        return (<BankPayment payment={payment}/>)
    }
    if (payment.stripePayment) {
        return (<StripePayment payment={payment}/>)
    }
    if (payment.payPalPaymentExecuted) {
        return (<PayPalPaymentExecuted payment={payment}/>)
    }
    return (
        null
    )
}


const PaymentList = ({ skipAuthorization = false, paymentList }) => {
    if (!skipAuthorization && !currentUserHasAccess(PAYMENT_LIST_WIDGET)) {
        return null
    }
    // sort by date
    paymentList.sort((a, b) => {
        return moment(a.date).unix() - moment(b.date).unix()
    })
    let sum = 0
    const currency = paymentList.length !== 0 ? paymentList[0].currency : 'EUR'
    return (
        <ContentBox title="Payments ">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th width="150">Date</th>
                                <th width="150">Channel</th>
                                <th width="150">Type</th>
                                <th>Reference</th>
                                <th width="150">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentList.map(payment => {
                                sum += payment.amount
                                return <Payment
                                    key={payment.id}
                                    payment={payment}
                                />
                            })}
                            <tr>
                                <td colSpan="4"><b>Total</b></td>
                                <td width="150" className="align-right"><b>{formatMoney(sum, currency)}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

PaymentList.propTypes = {
    skipAuthorization: PropTypes.bool,
    paymentList: PropTypes.array.isRequired,
}

export default PaymentList




// WEBPACK FOOTER //
// ./src/modules/payment/component/list/PaymentList.js